export function normalizeRecoveredShippingAddress(address) {
  if (!address || typeof address !== 'object') {
    return null;
  }

  const normalized = {
    address: address.address || address.street || '',
    address2: address.address2 || address.street2 || null,
    city: address.city || '',
    country: address.country || '',
    postalCode: address.postalCode || address.postal_code || address.zip || '',
    region: address.region || address.state || '',
  };
  const requiredValues = [
    normalized.address,
    normalized.city,
    normalized.country,
    normalized.postalCode,
    normalized.region,
  ];

  return requiredValues.every(
    (value) => typeof value === 'string' && value.trim().length > 0,
  )
    ? normalized
    : null;
}

export function recoveredCheckoutAttempt(attempt) {
  if (!attempt) {
    return null;
  }

  if (attempt.orderId && !attempt.id) {
    return {
      cartTransactionId: null,
      deliveryMethod: null,
      legacyValuesFrozen: true,
      missingQuotedEvidence: false,
      orderId: attempt.orderId,
      recovered: true,
      recoveryMode: 'completed',
      shippingAddress: null,
      status: 'completed',
      taxQuoteId: null,
    };
  }

  if (!attempt.id) {
    return null;
  }

  const quoted = Boolean(attempt.taxQuoteId);
  const shippingAddress = normalizeRecoveredShippingAddress(
    attempt.shippingAddress,
  );
  const status =
    attempt.state === 'reconciliation_required' ||
    attempt.reconciliationRequiredAt
      ? 'reconciliation_required'
      : attempt.state === 'successful'
        ? 'paid'
        : 'pending';
  const missingQuotedEvidence =
    quoted &&
    (!shippingAddress ||
      typeof attempt.deliveryMethod !== 'string' ||
      attempt.deliveryMethod.length === 0);

  return {
    cartTransactionId: attempt.id,
    deliveryMethod: attempt.deliveryMethod || null,
    legacyValuesFrozen: false,
    message: attempt.message || null,
    missingQuotedEvidence,
    orderId: attempt.orderId || null,
    recovered: true,
    recoveryMode: quoted ? 'quoted' : 'legacy',
    shippingAddress,
    status,
    taxQuoteId: attempt.taxQuoteId || null,
  };
}

export function canFinishPaidQuotedAttempt(attempt) {
  return Boolean(
    attempt?.status === 'paid' &&
      attempt.recoveryMode === 'quoted' &&
      attempt.cartTransactionId &&
      attempt.taxQuoteId &&
      attempt.shippingAddress &&
      attempt.deliveryMethod &&
      !attempt.missingQuotedEvidence &&
      !attempt.orderId,
  );
}

export function formatRetainedDestination(address) {
  if (!address) {
    return null;
  }

  return [
    address.address,
    address.address2,
    address.city,
    [address.region, address.postalCode].filter(Boolean).join(' '),
    address.country,
  ]
    .filter(Boolean)
    .join(', ');
}
